// Small pure helpers for Bank Jago as an RDN bank. Kept out of the components so Home.jsx
// and the summary page can use them without importing a step (the steps import the wizard
// for its context).
//
// Bank Jago is offered only while the backend says it is on (POST /api/jago/availability),
// but a member who already chose it must keep resolving after the switch goes off.

// Bank Jago is still in development: it is marked (DEV) wherever a person can read its name,
// and it is not offered at all until the backend says it is on. Remove the marker when it goes live.
export const JAGO_RDN_BANK = { value: 'jago', label: 'BANK JAGO (DEV)' };

// Bank Jago was Bank Artos. The customer's own bank list keeps the old name, and the stored value,
// until Bank Jago is switched on; then the entry is relabelled (the value never changes).
export const ARTOS_BANK_VALUE = 'pt_bank_artos_indonesia';
export const JAGO_OWN_BANK_LABEL = 'PT. BANK JAGO, Tbk (DEV)';

/** The customer-bank options with the former Bank Artos entry shown as Bank Jago. */
export function withJagoBankLabel(options) {
    return (options || []).map((o) => (o.value === ARTOS_BANK_VALUE ? { ...o, label: JAGO_OWN_BANK_LABEL } : o));
}

/** The options with Bank Jago appended, once. The list passed in is not changed. */
export function withJago(options) {
    const list = options || [];
    return list.some((o) => o.value === JAGO_RDN_BANK.value) ? list : [...list, JAGO_RDN_BANK];
}

/**
 * The RDN bank option for a value: from the list, or Bank Jago even when the list
 * does not carry it (switch off, saved member). Anything else not in the list is undefined.
 */
export function findRdnBank(value, options) {
    const found = (options || []).find((o) => o.value === value);
    if (found) return found;
    return value === JAGO_RDN_BANK.value ? JAGO_RDN_BANK : undefined;
}

/**
 * The RDN bank a member is saved with.
 *
 * A BCA customer is saved as 'bca' whatever was picked -- that is how it always was.
 * Bank Jago is the exception: it has to reach the backend as chosen, or a BCA customer
 * who picked it would be opened at BCA instead.
 *
 * @param registration  state.registration (rdn_bank is a value or an option object)
 * @param bankName      the customer's own bank, already resolved to a plain value
 */
export function resolveRdnBank(registration, bankName) {
    const picked = (registration.rdn_bank && typeof registration.rdn_bank === 'object') ? registration.rdn_bank.value : registration.rdn_bank;
    return (bankName === 'bca' && picked !== JAGO_RDN_BANK.value) ? bankName : picked;
}

/**
 * The consent field for the member payload: { jago_agree: '1' } when the RDN bank is
 * Bank Jago and the box was ticked, otherwise nothing at all (the key must be absent
 * for every other bank). The box is a single checkbox kept as an array.
 */
export function jagoAgreeField(rdnBank, jagoAgree) {
    const ticked = Array.isArray(jagoAgree) && jagoAgree.length > 0;
    return (rdnBank === JAGO_RDN_BANK.value && ticked) ? { jago_agree: '1' } : {};
}
